import { apiRequest } from './client';
import { endpoints } from './endpoints';

/** Selection sent to CBAPI calculate / calculate-filter. */
export interface CustomBetSelectionRequest {
  EventId: number;
  MarketId: string;
  OutcomeId: string;
  Specifier?: string | null;
  Odd?: number | null;
}

export interface CalculateCustomBetRequest {
  Selections: CustomBetSelectionRequest[];
}

export interface CustomBetOutcomeAvailability {
  OutcomeId: string;
  Name?: string | null;
  Odd?: number | null;
  Active?: boolean;
  Conflict?: boolean | null;
}

export interface CustomBetMarketAvailability {
  MarketId: string;
  Name?: string | null;
  Specifier?: string | null;
  Conflict?: boolean | null;
  Outcomes?: CustomBetOutcomeAvailability[] | null;
}

export interface AvailableSelectionsView {
  EventId: number;
  EventBId?: number;
  EventUrn?: string;
  Home?: string | null;
  Away?: string | null;
  Date?: string | null;
  Live?: boolean;
  Markets?: CustomBetMarketAvailability[] | null;
}

/** Response from `POST api/v1/custom-bets/calculate-filter`. */
export interface CalculationView {
  Odds: number;
  Probability?: number;
  Harmonization?: boolean;
  AvailableSelections?: AvailableSelectionsView[] | null;
  /** Some CBAPI builds return camelCase. */
  odds?: number;
  availableSelections?: AvailableSelectionsView[] | null;
}

function normalizeCalculation(raw: CalculationView): CalculationView {
  const odds = raw.Odds ?? raw.odds ?? 0;
  const available = raw.AvailableSelections ?? raw.availableSelections ?? null;
  return {
    ...raw,
    Odds: typeof odds === 'number' && Number.isFinite(odds) ? odds : 0,
    AvailableSelections: available,
  };
}

/**
 * Live price + conflict filter for an in-progress Bet Builder package.
 * Anonymous like legacy front AjaxCall (no CBAPI-specific token).
 */
export async function calculateCustomBetFilter(
  request: CalculateCustomBetRequest,
  signal?: AbortSignal,
): Promise<CalculationView> {
  const endpoint = endpoints.customBets.calculateFilter;
  const raw = await apiRequest<CalculationView>({
    host: endpoint.host,
    path: endpoint.path,
    method: 'POST',
    data: request as unknown as Record<string, unknown>,
    anonymous: true,
    ...(signal ? { signal } : {}),
  });
  return normalizeCalculation(raw ?? { Odds: 0 });
}
